import { fromPairs } from 'ramda';

import { getSafeTimeBounds } from '../selectors/timeBounds';

const setMetric = actionTypes => metric => ({
  type: actionTypes.SET_METRIC,
  payload: metric,
});

const setCrimeType = actionTypes => crimeType => ({
  type: actionTypes.SET_CRIME_TYPE,
  payload: crimeType,
});

const setCompare = actionTypes => compare => (dispatch, getState) => {
  const state = getState();

  dispatch({
    type: actionTypes.SET_COMPARE,
    payload: {
      compare,
      timeBounds: getSafeTimeBounds(state),
    },
  });
};

const setPrecision = actionTypes => precision => (dispatch, getState) => {
  const state = getState();

  dispatch({
    type: actionTypes.SET_PRECISION,
    payload: {
      precision,
      timeBounds: getSafeTimeBounds(state),
    },
  });
};

const setTimespan = actionTypes => timespan => (dispatch, getState) => {
  const state = getState();

  dispatch({
    type: actionTypes.SET_TIMESPAN,
    payload: {
      timespan,
      timeBounds: getSafeTimeBounds(state),
    },
  });
};

const setCustomTimespanInterval = actionTypes => interval => (
  dispatch,
  getState,
) => {
  const state = getState();

  dispatch({
    type: actionTypes.SET_CUSTOM_TIMESPAN_INTERVAL,
    payload: {
      interval,
      timeBounds: getSafeTimeBounds(state),
    },
  });
};

const setCustomCompareInterval = actionTypes => interval => ({
  type: actionTypes.SET_CUSTOM_COMPARE_INTERVAL,
  payload: interval,
});

export const createActionTypes = prefix =>
  fromPairs(
    [
      'SET_METRIC',
      'SET_CRIME_TYPE',
      'SET_PRECISION',
      'SET_TIMESPAN',
      'SET_COMPARE',
      'SET_CUSTOM_TIMESPAN_INTERVAL',
      'SET_CUSTOM_COMPARE_INTERVAL',
    ].map(actionType => [actionType, `${prefix}/${actionType}`]),
  );

export const createActionCreators = prefix => {
  const actionTypes = createActionTypes(prefix);

  return {
    setMetric: setMetric(actionTypes),
    setCrimeType: setCrimeType(actionTypes),
    setCompare: setCompare(actionTypes),
    setPrecision: setPrecision(actionTypes),
    setTimespan: setTimespan(actionTypes),
    setCustomTimespanInterval: setCustomTimespanInterval(actionTypes),
    setCustomCompareInterval: setCustomCompareInterval(actionTypes),
  };
};



// WEBPACK FOOTER //
// ./src/actions/optionsBase.js